export default __webpack_public_path__ + "static/media/III-2023.74b3238d.pdf";